import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface WidgetLayoutContextType {
  globalEditMode: boolean;
  setGlobalEditMode: (mode: boolean) => void;
  activeSectionId: string | null;
  setActiveSectionId: (id: string | null) => void;
}

const WidgetLayoutContext = createContext<WidgetLayoutContextType | undefined>(undefined);

export const WidgetLayoutProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [globalEditMode, setGlobalEditMode] = useState(false);
  const [activeSectionId, setActiveSectionId] = useState<string | null>(null);

  const handleSetGlobalEditMode = useCallback((mode: boolean) => {
    setGlobalEditMode(mode);
    if (!mode) {
      setActiveSectionId(null);
    }
  }, []);

  return (
    <WidgetLayoutContext.Provider 
      value={{ 
        globalEditMode, 
        setGlobalEditMode: handleSetGlobalEditMode,
        activeSectionId,
        setActiveSectionId,
      }}
    >
      {children}
    </WidgetLayoutContext.Provider>
  );
};

export const useWidgetLayoutContext = () => {
  const context = useContext(WidgetLayoutContext);
  if (context === undefined) {
    throw new Error('useWidgetLayoutContext must be used within a WidgetLayoutProvider');
  }
  return context;
};
